// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__XE6SQ","rotate":"Spinner_rotate__m6B5v"};